import { NAMESPACE } from '../constants';
const initialState = {
    isPlatformJourneyEnabled: false,
    isEligibleForVoucher: false,
    email: '',
    firstName: '',
    hasSecondaryAuth: false,
    onboardingType: 'DEFAULT',
};
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SET_PLATFORM_JOURNEY"] = "SET_PLATFORM_JOURNEY";
})(ACTIONS || (ACTIONS = {}));
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case `${NAMESPACE}/${ACTIONS.SET_PLATFORM_JOURNEY}`:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
export const getPlatformJourneyReducer = () => ({
    [NAMESPACE]: reducer,
});
//# sourceMappingURL=reducer.js.map